module.exports = __webpack_public_path__ + "img/screen_logo_2.8d24346f.png";